import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { createToolbarEvent } from "../../../analytics/AnalyticsEvents";
import { sendAnalytics } from "../../../analytics/functions";
// @ts-ignore
import { Icon } from "../../../base/icons";
import { IconAddUser, IconInviteMore } from "../../../base/icons/svg";
import Button from "../../../base/ui/components/web/Button";
import { BUTTON_TYPES } from "../../../base/ui/constants.web";
// eslint-disable-next-line lines-around-comment
// @ts-ignore
import { beginAddPeople } from "../../../invite";
// CUSTOM
import { close as closeParticipantsPane } from "../../actions.any";
// @ts-ignore
import { getBaseConfig } from "../../../customise/Utils";
// export const InviteButton = () => {
export const InviteButton = ({ isText }) => {
    // END
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const onInvite = useCallback(() => {
        sendAnalytics(createToolbarEvent("invite"));
        dispatch(beginAddPeople());
        // CUSTOM
        dispatch(closeParticipantsPane());
        // END
    }, [dispatch]);
    return (
    // CUSTOM
    React.createElement(React.Fragment, null, isText ? (React.createElement("span", { onClick: onInvite, style: {
            color: "white",
            textAlign: "center",
            display: "block",
            cursor: "pointer",
        } },
        "or",
        t("participantsPane.actions.invite"))) : (React.createElement(React.Fragment, null,
        getBaseConfig("socialAllowed") && (React.createElement(React.Fragment, null,
            React.createElement("span", { style: {
                    color: "white",
                    textAlign: "center",
                    display: "block",
                    cursor: "pointer",
                } }, "or"))),
        React.createElement(Button, { accessibilityLabel: t("participantsPane.actions.invite"), fullWidth: true, icon: IconAddUser, labelKey: "participantsPane.actions.invite", onClick: onInvite, type: BUTTON_TYPES.PRIMARY },
            React.createElement(Icon, { size: 20, src: IconInviteMore }),
            React.createElement("span", null, "Share Invite Link")))))
    // END
    );
};
